import type { ProductRestrictionFlag } from "../types/productV3";
import httpService from "./httpService";

export type ProductRestrictionProductType =
  | "BASKET"
  | "PORTFOLIO"
  | "MANAGED_STRATEGY";

export interface ProductRestrictionTradability {
  restrictedGrossPct: number | null;
  restrictedHoldingCount: number | null;
}

export interface ProductRestrictionDetails {
  restrictionFlags: ProductRestrictionFlag[];
  tradability: ProductRestrictionTradability;
}

class ProductRestrictionsService {
  async getProductRestrictions(
    productType: ProductRestrictionProductType,
    productId: number,
    signal?: AbortSignal
  ): Promise<ProductRestrictionDetails> {
    const response = await httpService.get<ProductRestrictionDetails>(
      `/v3/investor/product-restrictions/${productType}/${productId}`,
      { requiresAuth: true, signal }
    );
    return response.data;
  }
}

export const productRestrictionsService = new ProductRestrictionsService();
export default productRestrictionsService;
